import { render, staticRenderFns } from "./restricted.vue?vue&type=template&id=80ceb420&scoped=true&"
import script from "./restricted.vue?vue&type=script&lang=js&"
export * from "./restricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ceb420",
  null
  
)

export default component.exports